import { http } from "../http";

export interface BlogArticle {
  id: number;
  title: string;
  slug: string;
  content: string;
  excerpt?: string;
  featured_image?: string;
  status: "DRAFT" | "PUBLISHED" | "ARCHIVED";
  category?: string;
  tags?: string;
  is_featured: boolean;
  is_ai_generated?: boolean;
  seo_keywords?: string;
  faq_data?: string;
  language?: string;
  reading_time_min?: number;
  view_count: number;
  author_id?: number;
  author_name?: string;
  published_at?: string;
  created_at: string;
  updated_at: string;
  meta_title?: string;
  meta_description?: string;
}

export interface BlogFilters {
  status?: "DRAFT" | "PUBLISHED" | "ARCHIVED";
  category?: string;
  search?: string;
  is_featured?: boolean;
  tag?: string;
  limit?: number;
  offset?: number;
}

export interface BlogResponse {
  status: string;
  message?: string;
  data: BlogArticle;
}

export interface BlogListResponse {
  count: number;
  articles: BlogArticle[];
}

export interface BlogGeneratorStatus {
  totalTopicsInPool: number;
  totalGenerated: number;
  remaining: string;
  nextTopic: string | null;
}

export interface BlogGeneratorResult {
  success: boolean;
  articleId?: number;
  title?: string;
  slug?: string;
  error?: string;
}

export const blogService = {
  // Admin endpoints
  getBlogs: (filters: BlogFilters = {}) =>
    http.get<BlogListResponse>("/articles/admin/list", { params: filters }),

  getBlogById: (id: number) => http.get<BlogArticle>(`/articles/admin/${id}`),

  createBlog: (data: Partial<BlogArticle>) =>
    http.post<BlogResponse>("/articles", data),

  updateBlog: (id: number, data: Partial<BlogArticle>) =>
    http.patch<BlogResponse>(`/articles/${id}`, data),

  publishBlog: (id: number) =>
    http.post<BlogResponse>(`/articles/${id}/publish`),

  deleteBlog: (id: number) => http.delete(`/articles/${id}`),

  // Utilities
  getCategories: () => http.get<string[]>("/articles/categories"),

  getTags: () => http.get<string[]>("/articles/tags"),

  // Blog Generator (AI)
  triggerGeneration: () =>
    http.post<BlogGeneratorResult>("/blog-generator/generate"),

  getGeneratorStatus: () =>
    http.get<BlogGeneratorStatus>("/blog-generator/status"),
};
